module.exports = __webpack_public_path__ + "static/img/logo.f2ca08d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 1